import Main from 'components/Main';

import Table from "components/Table";

export default class TableEgisz extends Main {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
        };
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.items !== this.props.items || nextProps.tableMap !== this.props.tableMap;
    }

    render() {
        return (
            <Table
                map={this.props.tableMap}
                items={this.props.items}
            />
        );
    }
}

